export default "__VITE_ASSET__CP_e9Oy8__";